import React, { useEffect, useMemo, useState } from "react";

import "./styles/registration.css";

export default function Registration() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [active, setActive] = useState("home");
    const [lang, setLang] = useState("en");
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [phone, setPhone] = useState("");
    const [job, setJob] = useState("");
    const [location, setLocation] = useState("");
    const [degree, setDegree] = useState("");
    const [details, setDetails] = useState("");

    const [successMsg, setSuccessMsg] = useState("");
    const [successTimer, setSuccessTimer] = useState(null);



    const t = useMemo(
        () => ({
            en: {
                nav: { home: "Home", about: "About", register: "Register", contact: "Contact" },
                hero: {
                    title: "Find skilled workers near you",
                    desc:
                        "A single-page website with smooth scrolling between sections: Home, About, Register, and Contact — fully responsive.",
                    primary: "Register now",
                    secondary: "Contact us",
                    stats: [
                        { num: "Fast", label: "Smooth scroll" },
                        { num: "Clean", label: "Modern UI" },
                        { num: "Mobile", label: "Hamburger menu" },
                    ],
                    previewTitle: "Quick Preview",
                    preview: [
                        "Responsive navbar",
                        "Active section highlight",
                        "Complete register form",
                        "Contact icons + links",
                    ],
                },
                about: {
                    title: "About",
                    subtitle:
                        "This platform aims to connect skilled workers with clients through a simple and reliable experience.",
                    cards: [
                        { icon: "fa-screwdriver-wrench", title: "Services", text: "List skills clearly and help clients reach you quickly." },
                        { icon: "fa-location-dot", title: "Near You", text: "Enable location-based discovery to find the right person nearby." },
                        { icon: "fa-id-badge", title: "Profiles", text: "Show essential details such as job, location, and education." },
                    ],
                },
                register: {
                    title: "Register",
                    subtitle:
                        "Fill in your information to create a profile and appear in search results.",
                    fields: {
                        email: "Email",
                        username: "Username",
                        phone: "Phone Number",
                        job: "Job / Profession",
                        location: "City / Area",
                        degree: "Education / Degree",
                        more: "Additional details (optional)",
                    },
                    placeholders: {
                        email: "name@example.com",
                        username: "your username",
                        phone: "+961 ...",
                        job: "Carpenter, Plumber, Electrician...",
                        location: "Beirut, Bekaa, Tripoli...",
                        degree: "IT, Business, High School...",
                        more: "Write a short professional description of your skills...",
                    },
                    submit: "Submit",
                    back: "Back to Home",
                    tipsTitle: "Tips",
                    tipsText:
                        "Use accurate and professional information. This will appear on your profile and helps clients contact you.",
                    pills: ["Email", "Phone", "Job", "Location", "Degree"],
                    alertOk: "Registered ✅ (demo)",
                },
                contact: {
                    title: "Contact",
                    subtitle: "Reach us through social platforms or direct contact.",
                    social: "Social",
                    direct: "Direct",
                    facebook: "Facebook",
                    linkedin: "LinkedIn",
                    whatsapp: "WhatsApp",
                    phone: "+961 71 767957",
                    address: "Bekaana, Lebanon",
                    openLocation: "Open location",
                    backTop: "Back to top",
                },
            },

            ar: {
                nav: { home: "الرئيسية", about: "من نحن", register: "تسجيل", contact: "تواصل" },
                hero: {
                    title: "اعثر على عمّال مهرة بالقرب منك",
                    desc:
                        "موقع صفحة واحدة مع تمرير سلس بين الأقسام: الرئيسية، من نحن، التسجيل، والتواصل — ومتجاوب مع جميع الشاشات.",
                    primary: "سجّل الآن",
                    secondary: "تواصل معنا",
                    stats: [
                        { num: "سريع", label: "تمرير سلس" },
                        { num: "منظّم", label: "واجهة حديثة" },
                        { num: "متجاوب", label: "قائمة للهاتف" },
                    ],
                    previewTitle: "نظرة سريعة",
                    preview: [
                        "شريط تنقّل متجاوب",
                        "تحديد القسم الحالي تلقائيًا",
                        "نموذج تسجيل كامل",
                        "أيقونات وروابط للتواصل",
                    ],
                },
                about: {
                    title: "من نحن",
                    subtitle:
                        "تهدف هذه المنصة إلى ربط العمّال المهرة بالزبائن عبر تجربة بسيطة وموثوقة.",
                    cards: [
                        { icon: "fa-screwdriver-wrench", title: "الخدمات", text: "عرض المهارات بشكل واضح ومساعدة الزبائن على الوصول إليك بسرعة." },
                        { icon: "fa-location-dot", title: "بالقرب منك", text: "تسهيل البحث بحسب الموقع للعثور على الشخص المناسب في المنطقة." },
                        { icon: "fa-id-badge", title: "الملفات الشخصية", text: "إظهار معلومات أساسية مثل العمل، السكن، والتعليم." },
                    ],
                },
                register: {
                    title: "التسجيل",
                    subtitle:
                        "املأ معلوماتك لإنشاء ملف شخصي والظهور في نتائج البحث.",
                    fields: {
                        email: "البريد الإلكتروني",
                        username: "اسم المستخدم",
                        phone: "رقم الهاتف",
                        job: "المهنة / العمل",
                        location: "المدينة / المنطقة",
                        degree: "التعليم / الشهادة",
                        more: "تفاصيل إضافية (اختياري)",
                    },
                    placeholders: {
                        email: "name@example.com",
                        username: "اسم المستخدم",
                        phone: "+961 ...",
                        job: "نجّار، سبّاك، كهربائي...",
                        location: "بيروت، البقاع، طرابلس...",
                        degree: "تقنيات معلومات، إدارة أعمال، ثانوي...",
                        more: "اكتب وصفًا مهنيًا مختصرًا عن خبراتك ومهاراتك...",
                    },
                    submit: "إرسال",
                    back: "العودة للرئيسية",
                    tipsTitle: "نصائح",
                    tipsText:
                        "استخدم معلومات دقيقة وبأسلوب مهني. ستظهر هذه المعلومات في ملفك وتساعد الزبائن على التواصل معك.",
                    pills: ["البريد", "الهاتف", "المهنة", "الموقع", "الشهادة"],
                    alertOk: "تم التسجيل ✅ (تجريبي)",
                },
                contact: {
                    title: "تواصل",
                    subtitle: "يمكنك التواصل معنا عبر المنصات الاجتماعية أو عبر الهاتف.",
                    social: "اجتماعي",
                    direct: "مباشر",
                    facebook: "فيسبوك",
                    linkedin: "لينكدإن",
                    whatsapp: "واتساب",
                    phone: "+961 71 767957",
                    address: "بقاعنا، لبنان",
                    openLocation: "فتح الموقع",
                    backTop: "العودة للأعلى",
                },
            },
        }),
        []
    );

    const isRTL = lang === "ar";

    const scrollToId = (id) => {
        const el = document.getElementById(id);
        if (!el) return;

        const nav = document.querySelector(".nav");
        const offset = nav ? nav.offsetHeight : 0;

        const y = el.getBoundingClientRect().top + window.scrollY - offset - 8;
        window.scrollTo({ top: y, behavior: "smooth" });

        setMenuOpen(false);
    };

    useEffect(() => {
        const ids = ["home", "about", "register", "contact"];

        const handler = () => {
            const nav = document.querySelector(".nav");
            const offset = nav ? nav.offsetHeight : 0;
            const pos = window.scrollY + offset + 30;

            let current = "home";
            for (const id of ids) {
                const el = document.getElementById(id);
                if (el && pos >= el.offsetTop) current = id;
            }
            setActive(current);
        };

        handler();
        window.addEventListener("scroll", handler, { passive: true });
        return () => window.removeEventListener("scroll", handler);
    }, []);

    const L = t[lang];

    const [phoneError, setPhoneError] = useState("");
    const isLebanonMobile = (p) => /^(03|70|71|76|78|79|81)\d{6}$/.test(p);
    const isLebanonLandline = (p) => /^(01|04|05|06|07|08|09)\d{6}$/.test(p);

    const isValidPhone = (p) => isLebanonMobile(p);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isLebanonMobile(phone)) {
            setSuccessMsg(
                lang === "ar"
                    ? "فشل التسجيل ❌\nالسبب: رقم الهاتف غير لبناني أو غير صالح."
                    : "Registration failed ❌\nReason: Invalid or non-Lebanese phone number."
            );
            const timer = setTimeout(() => {
                setSuccessMsg("");
            }, 5000);

            setSuccessTimer(timer);

            return;
        }

        try {
            const res = await fetch("https://hcfullstack.onrender.com/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    username,
                    phone,
                    job,
                    location,
                    degree,
                    details,
                }),
            });

            const data = await res.json();

            if (data.success) {
                if (successTimer) clearTimeout(successTimer);

                setSuccessMsg(
                    lang === "ar"
                        ? "✅ تم إرسال بياناتك بنجاح، سنقوم بالتواصل معك قريبًا"
                        : "✅ Your information was submitted successfully. We will contact you soon."
                );

                const timer = setTimeout(() => {
                    setSuccessMsg("");
                }, 5000);

                setSuccessTimer(timer);



                setEmail("");
                setUsername("");
                setPhone("");
                setJob("");
                setLocation("");
                setDegree("");
                setDetails("");

            } else {

                alert(
                    lang === "ar"
                        ? "فشل التسجيل ❌\nالسبب: " + data.message
                        : "Registration failed ❌\nReason: " + data.message
                );
            }
        } catch (err) {
            alert(
                lang === "ar"
                    ? "خطأ في الاتصال بالسيرفر ❌"
                    : "Server connection error ❌"
            );
        }
    };



    return (
        <div className="page" dir={isRTL ? "rtl" : "ltr"}>
            {/* NAVBAR */}
            <header className="nav">
                <div className="nav__inner">
                    <div
                        className="brand"
                        onClick={() => scrollToId("home")}
                        role="button"
                        tabIndex={0}
                    >
                        <span className="brand__dot" />
                        <span className="brand__text">SkillConnect</span>
                    </div>

                    <nav className={`links ${menuOpen ? "links--open" : ""}`}>
                        <button
                            className={`link ${active === "home" ? "link--active" : ""}`}
                            onClick={() => scrollToId("home")}
                            type="button"
                        >
                            <i className="fa-solid fa-house" />
                            <span>{L.nav.home}</span>
                        </button>

                        <button
                            className={`link ${active === "about" ? "link--active" : ""}`}
                            onClick={() => scrollToId("about")}
                            type="button"
                        >
                            <i className="fa-solid fa-circle-info" />
                            <span>{L.nav.about}</span>
                        </button>

                        <button
                            className={`link ${active === "register" ? "link--active" : ""}`}
                            onClick={() => scrollToId("register")}
                            type="button"
                        >
                            <i className="fa-solid fa-user-plus" />
                            <span>{L.nav.register}</span>
                        </button>

                        <button
                            className={`link ${active === "contact" ? "link--active" : ""}`}
                            onClick={() => scrollToId("contact")}
                            type="button"
                        >
                            <i className="fa-solid fa-envelope" />
                            <span>{L.nav.contact}</span>
                        </button>
                    </nav>

                    {/* Language pills */}
                    <div className="langSwitch" aria-label="Language switch">
                        <button
                            type="button"
                            className={`langBtn ${lang === "en" ? "active" : ""}`}
                            onClick={() => setLang("en")}
                        >
                            EN
                        </button>
                        <button
                            type="button"
                            className={`langBtn ${lang === "ar" ? "active" : ""}`}
                            onClick={() => setLang("ar")}
                        >
                            AR
                        </button>
                    </div>

                    <button
                        className={`burger ${menuOpen ? "burger--open" : ""}`}
                        onClick={() => setMenuOpen((v) => !v)}
                        aria-label="Toggle menu"
                        type="button"
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </header>

                                                                     {/* SECTIONS */}
            <main className="content">
                                                    {/* HOME */}
                <section id="home" className="section hero ">
                    <div className="container">
                        <div className="hero__grid">
                            <div className="hero__text">
                                <h1>{L.hero.title}</h1>
                                <p>{L.hero.desc}</p>

                                <div className="hero__actions">
                                    <button
                                        className="btn btn--primary"
                                        onClick={() => scrollToId("register")}
                                        type="button"
                                    >
                                        {L.hero.primary}
                                    </button>
                                    <button
                                        className="btn btn--ghost"
                                        onClick={() => scrollToId("contact")}
                                        type="button"
                                    >
                                        {L.hero.secondary}
                                    </button>
                                </div>

                                <div className="stats">
                                    {L.hero.stats.map((s, idx) => (
                                        <div className="stat" key={idx}>
                                            <div className="stat__num">{s.num}</div>
                                            <div className="stat__label">{s.label}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="hero__card">
                                <div className="glass">
                                    <h3>{L.hero.previewTitle}</h3>
                                    <ul className="checklist">
                                        {L.hero.preview.map((x, idx) => (
                                            <li key={idx}>✅ {x}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ABOUT */}
                <section id="about" className="section">
                    <div className="container">
                        <div className="section__head">
                            <h2>{L.about.title}</h2>
                            <p>{L.about.subtitle}</p>
                        </div>

                        <div className="cards">
                            {L.about.cards.map((c, idx) => (
                                <div className="card" key={idx}>
                                    <div className="card__icon">
                                        <i className={`fa-solid ${c.icon}`} />
                                    </div>
                                    <h3>{c.title}</h3>
                                    <p>{c.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* REGISTER */}
                <section id="register" className="section section--alt">
                    <div className="container">
                        <div className="section__head">
                            <h2>{L.register.title}</h2>
                            <p>{L.register.subtitle}</p>
                        </div>

                        <div className="formWrap">
                            {successMsg && (
                                <div className="successBox">
                                    {successMsg}
                                </div>
                            )}

                            <form className="form" onSubmit={handleSubmit}>

                                <div className="grid2">
                                    <label className="field iconField">
                                        <span>{L.register.fields.email}</span>
                                        <div className="inputIcon">
                                            <i className="fa-solid fa-envelope" />
                                            <input
                                                type="email"
                                                placeholder={L.register.placeholders.email}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </label>

                                    <label className="field iconField">
                                        <span>{L.register.fields.username}</span>
                                        <div className="inputIcon">
                                            <i className="fa-solid fa-user" />
                                            <input
                                                type="text"
                                                placeholder={L.register.placeholders.username}
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </label>

                                    <label className="field iconField">

                                        <span>{L.register.fields.phone}</span>
                                        <div className="inputIcon">
                                            <i className="fa-solid fa-phone" />
                                            <input
                                                type="tel"
                                                inputMode="numeric"
                                                autoComplete="tel"
                                                placeholder="+961 70 123 456"
                                                value={phone}
                                                onChange={(e) => {
                                                    const digitsOnly = e.target.value.replace(/\D/g, "");
                                                    setPhone(digitsOnly);
                                                }}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    const pasted = (e.clipboardData || window.clipboardData).getData("text");
                                                    const digitsOnly = pasted.replace(/\D/g, "");
                                                    setPhone(digitsOnly);
                                                }}
                                                maxLength={8}
                                            />
                                            {phoneError && <div className="errorText">{phoneError}</div>}


                                        </div>
                                    </label>

                                    <label className="field iconField">
                                        <span>{L.register.fields.job}</span>
                                        <div className="inputIcon">
                                            <i className="fa-solid fa-briefcase" />
                                            <input
                                                type="text"
                                                placeholder={L.register.placeholders.job}
                                                value={job}
                                                onChange={(e) => setJob(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </label>

                                    <label className="field iconField">
                                        <span>{L.register.fields.location}</span>
                                        <div className="inputIcon">
                                            <i className="fa-solid fa-location-dot" />
                                            <input
                                                type="text"
                                                placeholder={L.register.placeholders.location}
                                                value={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </label>

                                    <label className="field iconField">
                                        <span>{L.register.fields.degree}</span>
                                        <div className="inputIcon">
                                            <i className="fa-solid fa-graduation-cap" />
                                            <input
                                                type="text"
                                                placeholder={L.register.placeholders.degree}
                                                value={degree}
                                                onChange={(e) => setDegree(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </label>
                                </div>

                                <label className="field">
                                    <span>{L.register.fields.more}</span>
                                    <textarea rows="4" placeholder={L.register.placeholders.more}
                                        value={details}
                                        onChange={(e) => setDetails(e.target.value)} />
                                </label>

                                <div className="formActions">
                                    <button className="btn btn--primary" type="submit">
                                        {L.register.submit}
                                    </button>
                                    <button
                                        className="btn btn--ghost"
                                        type="button"
                                        onClick={() => scrollToId("home")}
                                    >
                                        {L.register.back}
                                    </button>
                                </div>
                            </form>

                            <aside className="side">
                                <div className="side__box">
                                    <h3>{L.register.tipsTitle}</h3>
                                    <p>{L.register.tipsText}</p>
                                    <div className="pillRow">
                                        {L.register.pills.map((p, idx) => (
                                            <span className="pill" key={idx}>
                                                {p}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </section>

                                                               {/* CONTACT */}
                <section id="contact" className="section">
                    <div className="container">
                        <div className="section__head">
                            <h2>{L.contact.title}</h2>
                            <p>{L.contact.subtitle}</p>
                        </div>

                        <div className="contactGrid">
                            <div className="contactCard">
                                <div className="contactCard__title">{L.contact.social}</div>

                                <a
                                    className="contactItem"
                                    href="https://www.facebook.com/share/1ABS1kaM7z/?mibextid=wwXIfr"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="ico">
                                        <i className="fa-brands fa-facebook-f" />
                                    </span>
                                    <span>{L.contact.facebook}</span>
                                </a>

                                <a
                                    className="contactItem"
                                    href="https://www.linkedin.com/in/hussein-chehade-499996357"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="ico">
                                        <i className="fa-brands fa-linkedin-in" />
                                    </span>
                                    <span>{L.contact.linkedin}</span>
                                </a>

                                <a
                                    className="contactItem"
                                    href="https://wa.me/96171767957"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="ico">
                                        <i className="fa-brands fa-whatsapp" />
                                    </span>
                                    <span>{L.contact.whatsapp}</span>
                                </a>
                            </div>

                            <div className="contactCard">
                                <div className="contactCard__title">{L.contact.direct}</div>

                                <a className="contactItem" href="tel:+96171767957">
                                    <span className="ico">
                                        <i className="fa-solid fa-phone" />
                                    </span>
                                    <span>{L.contact.phone}</span>
                                </a>

                                <div className="contactItem" role="listitem">
                                    <span className="ico">
                                        <i className="fa-solid fa-location-dot" />
                                    </span>
                                    <span>{L.contact.address}</span>
                                </div>

                                <a
                                    className="contactItem"
                                    href="https://maps.app.goo.gl/dmYh3mA6M1XrePUa6"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className="ico">
                                        <i className="fa-solid fa-map-location-dot" />
                                    </span>
                                    <span>{L.contact.openLocation}</span>
                                </a>
                            </div>
                        </div>

                        <footer className="footer">
                            <span>© {new Date().getFullYear()} SkillConnect</span>
                            <button className="toTop" onClick={() => scrollToId("home")} type="button">
                                ↑ {L.contact.backTop}
                            </button>
                        </footer>
                    </div>
                </section>
            </main>
        </div>
    );
}
